const configDownloads = "https://drive.google.com/uc?export=download&id=";
export default configDownloads;
